import PurchaseList from './PurchaseList';
import PurchaseEdit from './PurchaseEdit';
import PurchaseCreate from './PurchaseCreate'


export default {
    list: PurchaseList,
    edit: PurchaseEdit,
    create:PurchaseCreate
};